<button mat-raised-button (click)="navigateToUserCreate()" color="primary">
    Novo Usuário
</button>

<app-user-read></app-user-read>